import { useState, type ReactNode } from "react"
import { CaretDown, CaretRight } from "@phosphor-icons/react"

/** A planning-hierarchy deep dive ("By Category"), collapsed until opened. */
export const LevelDisclosure = ({
  title,
  summary,
  children,
}: {
  title: string
  summary?: ReactNode
  children: ReactNode
}) => {
  const [open, setOpen] = useState(false)
  const Caret = open ? CaretDown : CaretRight
  const toggle = () => setOpen((o) => !o)
  return (
    <div className="flex flex-col gap-2 border-t border-base pt-3">
      <div
        role="button"
        tabIndex={0}
        aria-expanded={open}
        onClick={toggle}
        onKeyDown={(e) => {
          if (e.key !== "Enter" && e.key !== " ") return
          e.preventDefault()
          toggle()
        }}
        className="-mx-1 flex cursor-pointer items-center justify-between gap-2 rounded-md px-1 py-0.5 hover:bg-subtle"
      >
        <span className="flex items-center gap-1.5">
          <Caret className="size-3.5 shrink-0 text-fg-subtle" />
          <span className="label-sm text-fg-base">{title}</span>
        </span>
        {summary != null && <span className="paragraph-sm text-fg-subtle">{summary}</span>}
      </div>
      {open && children}
    </div>
  )
}
